import styled from "styled-components";
import {
  Grid,
  Typography,
  Stack,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Box,
  Tabs,
  Tab,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import usePincode from "../hooks/usePincode";
import { onlyNumber } from "../utils/inputHelper";
import { StyledInput } from "../components/ui/StyledInput";
import toast from "react-hot-toast";
import { Card } from "../components/ui/Card";
import { StyledSeperator } from "../components/ui/Seperator";
import {
  LocalShippingIcon,
  LocalAirportIcon,
  GpsFixedIcon,
} from "../common/iconsData";

import { getRateCalculator } from "../config/api";
import { StyledButton } from "../components/ui/StyledButton";
import BreadCrumbs from "../components/ui/BreadCrumbs";

export interface RateFormData {
  shipment_type: string;
  pickup_pincode: string;
  desti_pincode: string;
  invoice_value: string;
  cod: string;
  cod_amount: string;
  shipment_weight: string;
  shipment_length: string;
  shipment_width: string;
  shipment_height: string;
  is_return: boolean;
  boxes: string;
}

export interface ServiceFormData {
  delivery_by: string;
  mode: string;
  amount: string;
  service: string;
  cod_charge: string;
}

const StyleHidden = styled.div`
  width: 100%;
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.05);
  min-height: 400px;
`;
const Border = styled.div`
  border: 1px dotted #151515;
  height: 100px;
`;

const RateCalculator = () => {
  const [courierService, setCourierService] = useState<ServiceFormData[]>([]);
  const [ImmutabileCourierService, setImmutabileCourierService] = useState<
    ServiceFormData[]
  >([]);
  const [canSubmit, setCanSubmit] = useState(false);

  const [formData, setFormData] = useState<RateFormData>({
    shipment_type: "",
    pickup_pincode: "",
    desti_pincode: "",
    invoice_value: "",
    cod: "",
    cod_amount: "",
    boxes: "",
    shipment_weight: "",
    shipment_length: "",
    shipment_width: "",
    shipment_height: "",
    is_return: false,
  });

  useEffect(() => {
    if (
      formData.shipment_type == "" ||
      formData.pickup_pincode == "" ||
      formData.desti_pincode == "" ||
      formData.invoice_value == "" ||
      // formData.cod == "" ||
      formData.boxes == "" ||
      formData.shipment_weight == "" ||
      formData.shipment_length == "" ||
      formData.shipment_width == "" ||
      formData.shipment_height == ""
    ) {
      setCanSubmit(false);
    } else {
      setCanSubmit(true);
    }
    console.log(formData);
  }, [formData]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = event.target;

    if (name === "pickup_pincode") {
      event.target.value = onlyNumber(event, 6);
      setPickupPincode(event.target.value);
    }
    if (name === "desti_pincode") {
      event.target.value = onlyNumber(event, 6);
      setDeliveryPincode(event.target.value);
    }
    if (name === "shipment_type") {
      setSelectedValue(event.target.value as "forward" | "return");
      if (event.target.value == "return") {
        setIsReturn(true);
      } else {
        setIsReturn(false);
      }
    }

    if (name === "cod_amount") {
      event.target.value = onlyNumber(event, Infinity);
    }

    if (name === "cod") {
      if (event.target.value == "true") {
        setCodVal(true);
      } else {
        setCodVal(false);
      }
    }

    setFormData({ ...formData, [name]: event.target.value });
  };

  const [selectedValue, setSelectedValue] = useState<"forward" | "return">(
    "forward"
  );
  const [pickupPincode, setPickupPincode] = useState<string>("");
  const [deliveryPincode, setDeliveryPincode] = useState<string>("");

  const { city: pickupCity, state: pickupState } = usePincode(pickupPincode);

  const { city: deliveryCity, state: deliveryState } =
    usePincode(deliveryPincode);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    getRateCalculator(formData)
      .then((data) => {
        setImmutabileCourierService(data?.data?.data);
        setCourierService(data?.data?.data);
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error);
        }
      });
  };

  const handleFormReset = () => {
    setFormData({
      shipment_type: "",
      pickup_pincode: "",
      desti_pincode: "",
      invoice_value: "",
      cod: "",
      cod_amount: "",
      boxes: "",
      shipment_weight: "",
      shipment_length: "",
      shipment_width: "",
      shipment_height: "",
      is_return: isReturn,
    });
    setCourierService([]);
  };

  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: any) => {
    setActiveTab(newValue);
  };
  const [courierType, setCourierType] = useState("");

  useEffect(() => {
    if (courierType !== "") {
      const newData = ImmutabileCourierService.filter(
        (single) => single.mode == courierType
      );
      setCourierService(newData);
    } else {
      setCourierService(ImmutabileCourierService);
    }
  }, [courierType]);

  const [codVal, setCodVal] = useState(false);
  const [isReturn, setIsReturn] = useState(false);

  return (
    <>
      <BreadCrumbs
        field="tools"
        link={"/tools"}
        extra={[
          {
            text: "Rate Calculator",
          },
        ]}
      />

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Card>
              <FormControl>
                <FormLabel>
                  <Typography fontSize={12}>Shipment type</Typography>
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="forward"
                  name="shipment_type"
                  onChange={handleInputChange}
                  value={formData.shipment_type}
                >
                  <Stack direction={"row"}>
                    <FormControlLabel
                      value="forward"
                      control={<Radio size="small" />}
                      label={<Typography fontSize={12}>Forward</Typography>}
                    />
                    <FormControlLabel
                      value="return"
                      control={<Radio size="small" />}
                      label={<Typography fontSize={12}>Return</Typography>}
                    />
                  </Stack>
                </RadioGroup>
              </FormControl>

              <>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Grid item xs={10}>
                      <FormLabel>
                        <Typography fontSize={12}>Pickup Pincode</Typography>
                      </FormLabel>
                      <StyledInput
                        variant="outlined"
                        placeholder="Enter 6 digit pickup area pincode"
                        fullWidth
                        name="pickup_pincode"
                        onChange={handleInputChange}
                        value={formData.pickup_pincode}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={10}>
                      <FormLabel>
                        <Typography fontSize={12}>
                          Enter 6 digit delivery pincode
                        </Typography>
                      </FormLabel>
                      <StyledInput
                        fullWidth
                        onChange={handleInputChange}
                        placeholder="Address Line 1"
                        name="desti_pincode"
                        value={formData.desti_pincode}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack direction={"row"} gap={1}>
                      <Grid item xs={5}>
                        <FormLabel>
                          <Typography fontSize={12}>Actual Weight</Typography>
                        </FormLabel>
                        <StyledInput
                          variant="outlined"
                          placeholder="0.00"
                          fullWidth
                          name="shipment_weight"
                          onChange={handleInputChange}
                          value={formData.shipment_weight}
                        />
                      </Grid>

                      <Grid item xs={5}>
                        <FormLabel>
                          <Typography fontSize={12}>Box Count</Typography>
                        </FormLabel>
                        <StyledInput
                          variant="outlined"
                          placeholder="eg: 10"
                          fullWidth
                          name="boxes"
                          onChange={handleInputChange}
                          value={formData.boxes}
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <FormLabel>
                      <Typography fontSize={12}>Dimensions</Typography>
                    </FormLabel>
                    <Grid container spacing={2}>
                      <Grid item xs={3}>
                        <StyledInput
                          variant="outlined"
                          placeholder="L:cm"
                          fullWidth
                          name="shipment_length"
                          onChange={handleInputChange}
                          value={formData.shipment_length}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <StyledInput
                          variant="outlined"
                          placeholder="B:cm"
                          fullWidth
                          name="shipment_width"
                          onChange={handleInputChange}
                          value={formData.shipment_width}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <StyledInput
                          variant="outlined"
                          placeholder="H:cm"
                          fullWidth
                          name="shipment_height"
                          onChange={handleInputChange}
                          value={formData.shipment_height}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {selectedValue === "forward" && (
                    <Grid item xs={6}>
                      <FormControl>
                        <FormLabel>
                          <Typography fontSize={12}>Payment Type</Typography>
                        </FormLabel>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue=""
                          name="cod"
                          onChange={handleInputChange}
                          value={formData.cod}
                        >
                          <Stack direction={"row"}>
                            <FormControlLabel
                              value="true"
                              control={<Radio size="small" />}
                              label={
                                <Typography fontSize={12}>
                                  Cash on delivery
                                </Typography>
                              }
                            />
                            <FormControlLabel
                              value="false"
                              control={<Radio size="small" />}
                              label={
                                <Typography fontSize={12}>Prepaid</Typography>
                              }
                            />
                          </Stack>
                        </RadioGroup>
                      </FormControl>

                      {codVal == true && (
                        <FormControl>
                          <FormLabel>
                            <Typography fontSize={12}>COD amount</Typography>
                          </FormLabel>
                          <Grid item xs={8}>
                            <StyledInput
                              variant="outlined"
                              placeholder="eg: 1500"
                              fullWidth
                              name="cod_amount"
                              onChange={handleInputChange}
                              value={formData.cod_amount}
                            />
                          </Grid>
                        </FormControl>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={6}>
                    <Grid item xs={10}>
                      <FormLabel>
                        <Typography fontSize={12}>
                          Shipment Value (₹)
                        </Typography>
                      </FormLabel>
                      <StyledInput
                        variant="outlined"
                        placeholder="0.00"
                        fullWidth
                        name="invoice_value"
                        onChange={handleInputChange}
                        value={formData.invoice_value}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl>
                      <FormLabel>
                        <Typography fontSize={12}>
                          Shipping Dangerous Goods?
                        </Typography>
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue=""
                        name="radio-buttons-group"
                      >
                        <Stack direction={"row"}>
                          <FormControlLabel
                            value="yes"
                            control={<Radio size="small" />}
                            label={<Typography fontSize={12}>Yes</Typography>}
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" />}
                            label={<Typography fontSize={12}>No</Typography>}
                          />
                        </Stack>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {selectedValue === "return" && (
                    <Grid item xs={6}>
                      <FormControl>
                        <FormLabel>
                          <Typography fontSize={12}>QC Applicable?</Typography>
                        </FormLabel>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue=""
                          name="radio-buttons-group"
                        >
                          <Stack direction={"row"}>
                            <FormControlLabel
                              value="yes"
                              control={<Radio size="small" />}
                              label={<Typography fontSize={12}>Yes</Typography>}
                            />
                            <FormControlLabel
                              value="Prepaid"
                              control={<Radio size="small" />}
                              label={<Typography fontSize={12}>No</Typography>}
                            />
                          </Stack>
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Grid item xs={4}>
                      <Stack direction={"row"} gap={2}>
                        <StyledButton
                          type="submit"
                          variant="contained"
                          fullWidth
                          disabled={!canSubmit}
                        >
                          <p>Calculate</p>
                        </StyledButton>
                        <StyledButton
                          variant="outlined"
                          fullWidth
                          onClick={handleFormReset}
                        >
                          <p>Reset</p>
                        </StyledButton>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            </Card>
          </Grid>
          <Grid item xs={4}>
            <Card>
              <Stack justifyContent={"center"} alignItems={"center"} rowGap={2}>
                <Stack
                  justifyContent={"center"}
                  direction={"row"}
                  alignItems={"center"}
                  gap={1}
                >
                  <GpsFixedIcon />
                  <Typography textAlign={"center"}>Pickup Location</Typography>
                </Stack>
                <StyledInput
                  sx={{
                    ">div input": {
                      padding: "10px",
                    },
                  }}
                  value={pickupCity && `${pickupCity},${pickupState}`}
                  variant="outlined"
                  disabled
                  placeholder="City, State"
                />
                <Border />
                <Stack
                  justifyContent={"center"}
                  direction={"row"}
                  alignItems={"center"}
                  gap={1}
                >
                  <GpsFixedIcon />
                  <Typography textAlign={"center"}>
                    Delivery Location
                  </Typography>
                </Stack>
                <StyledInput
                  sx={{
                    ">div input": {
                      padding: "10px",
                    },
                  }}
                  value={deliveryCity && `${deliveryCity},${deliveryState}`}
                  variant="outlined"
                  disabled
                  placeholder="City, State"
                />
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </form>

      {courierService && (
        <Grid container spacing={2} mt={2}>
          <Grid item xs={8}>
            <Card>
              <FormControl>
                <FormLabel>Serviceable Courier Partners</FormLabel>
              </FormControl>
              <StyledSeperator />

              <StyleHidden>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                  }}
                >
                  <Tabs
                    value={activeTab}
                    onChange={(
                      e: React.SyntheticEvent<Element, Event>,
                      number: any
                    ) => handleTabChange(e, number)}
                    variant="scrollable"
                  >
                    <Tab label={"All"} onClick={() => setCourierType("")} />;
                    <Tab
                      label={"By Air"}
                      onClick={() => setCourierType("by air")}
                    />
                    ;
                    <Tab
                      label={"By Surface"}
                      onClick={() => setCourierType("by surface")}
                    />
                    ;
                  </Tabs>
                </Box>

                <TableContainer
                  sx={{
                    marginTop: "20px",
                  }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ textAlign: "center" }}>
                          Courier Partner
                        </TableCell>
                        <TableCell>Mode</TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          Amount
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          COD Amount
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          Estimated Delivery Date
                        </TableCell>
                        {/* <TableCell style={{ textAlign: "center" }}>
                          Action
                        </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {courierService &&
                        courierService?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ textAlign: "center" }}>
                              {row?.service}
                            </TableCell>
                            <TableCell>
                              <div style={{ display: "flex" }}>
                                {row?.mode == "by air" ? (
                                  <>
                                    <LocalAirportIcon
                                      color="primary"
                                      sx={{
                                        fontSize: "22px",
                                        // border: "1px solid #eceef0",
                                        // borderRadius: "50%",
                                        padding: "0px",
                                      }}
                                    />
                                    : Air
                                  </>
                                ) : row?.mode == "by surface" ? (
                                  <>
                                    <LocalShippingIcon
                                      color="primary"
                                      sx={{
                                        fontSize: "22px",
                                        border: "1px solid #eceef0",
                                        borderRadius: "50%",
                                        padding: "0px",
                                      }}
                                    />
                                    : Surface
                                  </>
                                ) : (
                                  "Mode Not Defind"
                                )}
                              </div>
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row?.amount}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row?.cod_charge}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row?.delivery_by}
                            </TableCell>
                            {/* <TableCell style={{ textAlign: "center" }}>
                              <Button
                                sx={{
                                  padding: "6px 20px",
                                  display: "block",
                                  marginBottom: "8px",
                                }}
                                variant="contained"
                                onClick={
                                  () => ""
                                }
                              >
                                <InsideButton>
                                 
                                  <p>Create Shipment</p>
                                </InsideButton>
                              </Button>
                            </TableCell> */}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </StyleHidden>
            </Card>
          </Grid>

          <Grid item xs={4}>
            <Card>
              <FormControl>
                <FormLabel>Order Details</FormLabel>
              </FormControl>
              {/* <Typography variant="h6">
              Order Details
            </Typography> */}
              <StyledSeperator />

              <StyleHidden>
                {courierService[0] && (
                  <>
                    <Typography>
                      Pickup From: {formData.pickup_pincode} ,{" "}
                      {pickupCity && `${pickupCity}, ${pickupState}`}.
                    </Typography>
                    <StyledSeperator />

                    <Typography>
                      Delivery To: {formData.desti_pincode} ,{" "}
                      {deliveryCity && `${deliveryCity}, ${deliveryState}`}.
                    </Typography>
                    <StyledSeperator />

                    <Typography>
                      Shipment Type: {formData.shipment_type}.
                    </Typography>
                    <StyledSeperator />

                    <Typography>
                      Shipment Value: {formData.invoice_value}.
                    </Typography>

                    <StyledSeperator />

                    <Typography>
                      Payment Mode: {formData.cod == "true" ? "COD" : "PREPAID"}
                      .
                    </Typography>
                    <StyledSeperator />

                    <Typography>
                      Applicable Weight (in Kg): {formData.shipment_weight}.
                    </Typography>
                  </>
                )}
              </StyleHidden>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};

const InsideButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
`;
export default RateCalculator;
